<template>
    <tr>
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding">
          <input type="checkbox"
                 :id="entity.id"
                 :value="entity.id"
                 @change="onChange"
                 :checked="isChecked"
                 @click.stop
          />
          <label :for="entity.id" @click.stop v-translate>Vybrat</label>
        </td>
        <td class="first_data" data-th="Cena"><strong>{{ entity.formated_value }}</strong></td>
        <td data-th="Symbol">{{ entity.currency_symbol }}</td>
        <td data-th="Název měny">{{ entity.currency_name }}</td>
    </tr>
</template>

<script>
	export default {
		name: "PackageRow",
		props: {
			entity: Object,
      selectedEntities: Array,
      isDeletable: Boolean,
      idSubscriber: Number,
		},
        methods: {
          onChange: function (e) {
            this.$emit('input', e)
          },
          toDetail(id){
              this.$router.push({name: 'vodPackagesDetail', params: {id: id}});
          },
        },
        computed: {
          isChecked() {
            return this.selectedEntities.indexOf(String(this.entity.id)) > -1
          },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/views/vodVideos/detail/PricesRow.vue